/* MOSZACI PREMIUM: behaviour layer. No dependencies. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var MZ = window.MZ || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { doc.readyState !== 'loading' ? fn() : doc.addEventListener('DOMContentLoaded', fn); }
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  /* ---------- colour helpers ---------- */
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), h = 0, s = 0, l = (max + min) / 2, d = max - min;
    if (d) {
      s = l > .5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return [h, s, l];
  }
  function hslToRgb(h, s, l) {
    function f(p, q, t) { if (t < 0) t += 1; if (t > 1) t -= 1; if (t < 1 / 6) return p + (q - p) * 6 * t; if (t < 1 / 2) return q; if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6; return p; }
    var q = l < .5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
    return [Math.round(f(p, q, h + 1 / 3) * 255), Math.round(f(p, q, h) * 255), Math.round(f(p, q, h - 1 / 3) * 255)];
  }
  function hex(rgb) { return '#' + rgb.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join(''); }
  function parseHex(h) {
    h = String(h).replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    if (!/^[0-9a-f]{6}$/i.test(h)) return null;
    return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
  }
  function applyAccent(rgb) {
    var hsl = rgbToHsl(rgb[0], rgb[1], rgb[2]);
    var hov = hslToRgb(hsl[0], hsl[1], Math.max(0, hsl[2] - .08));
    var lum = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]);
    var st = root.style;
    st.setProperty('--mz-accent', hex(rgb));
    st.setProperty('--mz-accent-hover', hex(hov));
    st.setProperty('--mz-accent-soft', 'rgba(' + rgb.join(',') + ',.12)');
    st.setProperty('--mz-on-accent', lum > 170 ? '#151413' : '#ffffff');
    root.classList.add('mz-auto-ready');
  }

  /* ---------- 1. header state on scroll ---------- */
  function headerState() {
    var on = false;
    function tick() { var s = (window.pageYOffset || root.scrollTop) > 40; if (s !== on) { on = s; root.classList.toggle('mz-scrolled', s); } }
    window.addEventListener('scroll', tick, { passive: true }); tick();
  }

  /* ---------- 2. per-product colour ---------- */
  function productColour() {
    var qs = /[?&]mz_accent=([0-9a-fA-F]{3,6})/.exec(location.search);
    if (qs) { var p = parseHex(qs[1]); if (p) { applyAccent(p); root.setAttribute('data-mz-color-source', 'product'); return; } }
    if (MZ.colorSource !== 'auto') return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;
    var key = 'mz-acc-' + handle;
    try { var c = sessionStorage.getItem(key); if (c) { var pc = parseHex(c); if (pc) { applyAccent(pc); return; } } } catch (e) {}

    var img = $('#product-featured-image') || $('.product-photo-container img') || $('.product-img-box img');
    var src = img && (img.currentSrc || img.src);
    if (!src) { var og = $('meta[property="og:image"]'); src = og && og.content; }
    if (!src) return;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/cdn\.shopify\.com/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=90';

    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = 40, h = 40, cv = doc.createElement('canvas'); cv.width = w; cv.height = h;
        var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, w, h);
        var d = cx.getImageData(0, 0, w, h).data, B = {}, best = null, total = 0;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 200) continue;
          var hsl = rgbToHsl(d[i], d[i + 1], d[i + 2]);
          if (hsl[2] > .93 || hsl[2] < .1 || hsl[1] < .18) continue;     /* ignore white, black, grey */
          var wgt = hsl[1] * hsl[1] * (1 - Math.abs(hsl[2] - .5));
          var k = Math.round(hsl[0] * 24) % 24;
          var b = B[k] || (B[k] = { w: 0, r: 0, g: 0, b: 0 });
          b.w += wgt; b.r += d[i] * wgt; b.g += d[i + 1] * wgt; b.b += d[i + 2] * wgt; total += wgt;
          if (!best || b.w > best.w) best = b;
        }
        if (!best || total < 3) return;                                   /* neutral product: keep brand accent */
        var rgb = [best.r / best.w, best.g / best.w, best.b / best.w];
        var H = rgbToHsl(rgb[0], rgb[1], rgb[2]);
        var out = hslToRgb(H[0], Math.min(.8, Math.max(.35, H[1])), Math.min(.46, Math.max(.28, H[2])));
        applyAccent(out);
        try { sessionStorage.setItem(key, hex(out)); } catch (e) {}
      } catch (e) { /* canvas blocked: keep brand accent */ }
    };
    im.src = src;
  }

  /* ---------- 3. sticky add to cart ---------- */
  function stickyAtc() {
    var bar = $('.mz-sticky'), btn = $('#AddToCart');
    if (!bar || !btn || MZ.stickyAtc === false) return;
    var go = $('.btn', bar);
    go.addEventListener('click', function (e) { e.preventDefault(); if (!btn.disabled) btn.click(); });
    var price = $('.mz-sticky__price', bar), src = $('#ProductPrice');
    if (price && src && 'MutationObserver' in window) {
      new MutationObserver(function () { price.textContent = src.textContent.trim(); })
        .observe(src, { childList: true, characterData: true, subtree: true });
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      var e = en[0], below = e.boundingClientRect.top < 0;
      var show = !e.isIntersecting && below;
      bar.classList.toggle('is-visible', show);
      root.classList.toggle('mz-sticky-on', show);
    }, { threshold: 0 });
    io.observe(btn);
  }

  /* ---------- 4. cart page: auto-update quantities ---------- */
  function cartPage() {
    var f = $('.mz-cart__form'); if (!f) return;
    var up = $('.mz-update', f), t;
    function queue() { clearTimeout(t); t = setTimeout(function () { up && up.click(); }, 800); }
    f.addEventListener('change', function (e) { if (e.target.classList.contains('cart-number')) queue(); });
    f.addEventListener('click', function (e) {
      if (e.target.classList.contains('qtyplus1') || e.target.classList.contains('qtyminus1')) queue();
    });
  }

  /* ---------- 5. back to top (vanilla; replaces the legacy jQuery plugin button) ---------- */
  function backToTop() {
    if ($('.mz-top')) return;
    var label = { nl: 'Naar boven', de: 'Nach oben' }[(root.lang || 'en').slice(0, 2)] || 'Back to top';
    var b = doc.createElement('button');
    b.type = 'button'; b.className = 'mz-top'; b.setAttribute('aria-label', label); b.title = label;
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    doc.body.appendChild(b);
    var on = false;
    function tick() { var s = (window.pageYOffset || root.scrollTop) > 500; if (s !== on) { on = s; b.classList.toggle('is-visible', s); } }
    window.addEventListener('scroll', tick, { passive: true }); tick();
  }

  /* ---------- 6. gentle scroll reveal for product grids and section headings ---------- */
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = $$('.home-product-grid-type-4 .item-row, .home-product-grid-type-4 .section-header, .collection_grid_template .item-row, .grid-banner-type-29 img, .newsletter-section');
    if (!els.length) return;
    root.classList.add('mz-js');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mz-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { el.classList.add('mz-reveal'); io.observe(el); });
    /* safety net: never leave anything hidden */
    setTimeout(function () { els.forEach(function (el) { el.classList.add('mz-in'); }); }, 6000);
  }

  ready(function () { headerState(); productColour(); stickyAtc(); cartPage(); backToTop(); reveal(); });
})();
